let uid = 0

export default {
    beforeCreate: function () {
        this.$uid = uid.toString()
        uid++
    },
    methods:      {
        /**
         * Returns an unique id for the component.
         *
         * @param id
         * @returns {*}
         */
        uniqid: function (id) {
            return id + '_' +this.$uid;
        }
    }
}
